// frontend-react/src/config/api.ts

/**
 * 取得 API 的基礎 URL。
 * 優先使用環境變數 REACT_APP_API_URL。
 * 若無設定，則在正式環境使用相對路徑 '/api'，交給 Nginx 代理。
 */
export const getApiBaseUrl = (): string => {
  // 1. 優先檢查編譯時注入的環境變數 (Build Time)
  const envUrl = process.env.REACT_APP_API_URL;

  if (envUrl) {
    // 開發或測試機 (Staging) 會明確指定完整的 URL (http://domain:port)
    return envUrl;
  }

  // 2. 如果沒有設定環境變數，則使用相對路徑
  // 🚨 這是正式環境 (Production) 的預設行為
  // 🚨 Nginx (443) 會將 /api 轉發給後端 (8003)
  return '';
};

export const API_ENDPOINTS = {
  // Contract comparison endpoints
  parse: '/api/v1/contract-diff/parse',
  diffSections: '/api/v1/contract-diff/diff-sections',
  aiAnalyze: '/api/v1/contract-diff/ai/analyze',

  // Ad review endpoints
  review: '/api/review/review',
  reviewSubmit: '/api/review/submit',
  reviewStatus: '/api/review/status', // + /{job_id}
  reviewCancel: '/api/review/cancel', // POST + /{job_id}
  health: '/api/review/health',
  reviewPreview: '/api/review/preview-file',
  downloadCommentedWord: '/api/review/download-commented-word',
  companyUsage: '/api/review/usage/company-total',
  customRuleSets: '/api/custom-rules/list',
} as const;

const apiConfig = {
  getApiBaseUrl,
  API_ENDPOINTS,
};

export default apiConfig;
